import HeatingModuleV001 from "../../Portal/Accessor/Module/V001/ExistingHome/HeatingModule";
import CoolingModuleV001 from "../../Portal/Accessor/Module/V001/ExistingHome/CoolingModule";
import LightingModuleV001 from "../../Portal/Accessor/Module/V001/ExistingHome/LightingModule";
import PlugLoadCookingModuleV001 from "../../Portal/Accessor/Module/V001/ExistingHome/PlugLoadCookingModule";
import HotWaterModuleV001 from "../../Portal/Accessor/Module/V001/ExistingHome/HotWaterModule";
import PoolSpaModuleV001 from "../../Portal/Accessor/Module/V001/ExistingHome/PoolSpaModule";
import SolarPvModuleV001 from "../../Portal/Accessor/Module/V001/ExistingHome/SolarPvModule";
import ModuleSummary from "../../Portal/Accessor/Module/ModuleSummary";
const AccessorModuleExistingHomeRouters = [
    {
        path: "HeatingAssessor/ExistingHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <HeatingModuleV001/>,
        title: "Heating | AccuRate Enterprise",
    },
    {
        path: "CoolingAssessor/ExistingHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <CoolingModuleV001/>,
        title: "Cooling | AccuRate Enterprise",
    },
    {
        path: "LightingAssessor/ExistingHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <LightingModuleV001/>,
        title: "Lighting | AccuRate Enterprise",
    },
    {
        path: "PlugLoadAssessor/ExistingHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <PlugLoadCookingModuleV001/>,
        title: "Plug Load & Cooking | AccuRate Enterprise",
    },
    {
        path: "HotWaterAssessor/ExistingHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <HotWaterModuleV001/>,
        title: "Hot Water | AccuRate Enterprise",
    },
    {
        path: "PoolSpaAssessor/ExistingHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <PoolSpaModuleV001/>,
        title: "Pool & Spa | AccuRate Enterprise",
    },
    {
        path: "SolarPvAssessor/ExistingHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <SolarPvModuleV001/>,
        title: "Solar PV | AccuRate Enterprise",
    },
    {
        path: "ModuleSummaryAssessor/ExistingHome/Detail/:designVariationVersionName/:designVariationId/:projectId",
        exact: true,
        requireAuth: true,
        element: <ModuleSummary/>,
        title: "Summary | AccuRate Enterprise",
    },
];
export default AccessorModuleExistingHomeRouters;